import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/tenant-settings/industry-packs")({
  component: Outlet,
});
